/**
 * ============================================================================
 * TYNA — comportamentos customizados
 * ============================================================================
 * Este arquivo NÃO faz parte do tema base (Release v2.0.4, DigiFist).
 *
 * Todo comportamento específico da TYNA mora aqui. Nada de código próprio
 * dentro de assets/global.js, assets/cart.js ou assets/quick-cart-drawer.js —
 * esses são arquivos do fornecedor e são substituídos por inteiro quando o
 * tema é atualizado.
 *
 * Carregado em layout/theme.liquid com `defer`, depois de global.js.
 *
 * Conteúdo:
 *   1. Utilidades       — cor da marca lida do CSS
 *   2. Card de produto  — seletor de tamanho e adicionar à sacola
 *   3. Card de produto  — aviso "escolha um tamanho"
 *   4. Banners          — rede de segurança do autoplay de vídeo
 * ============================================================================
 */
(function () {
  'use strict';

  /* ==========================================================================
     1. UTILIDADES
     ========================================================================== */

  /**
   * Cor da marca. A fonte única é a variável --tyna-brand em
   * assets/tyna-custom.css. Lendo daqui, mudar a cor continua sendo
   * uma edição em um lugar só.
   */
  var BRAND = (function () {
    var v = getComputedStyle(document.documentElement).getPropertyValue('--tyna-brand');
    return (v || '').trim() || '#8a6a52';
  })();

  var SIZE_HINT_CLASS = 'tyna-size-hint';
  var SIZE_ATTENTION_CLASS = 'tyna-sizes--attention';
  var SIZE_HINT_TIMEOUT_MS = 4000;

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }

  /* ==========================================================================
     2. CARD DE PRODUTO — seletor de tamanho e adicionar à sacola
     ==========================================================================
     Extraído de assets/global.js (linhas 3247-3329), onde estava colado no
     fim de um arquivo do fornecedor.

     Mudanças feitas na extração:
     · A cor do tamanho selecionado passou a ser a da marca diretamente. Antes
       o global.js pintava de preto e um <script> no layout/theme.liquid
       reescrevia a função em runtime, com setInterval de 100ms por até 6
       segundos, só para trocar a cor. Esse monkey-patch foi eliminado.
     · O refetch de `?sections=cart-drawer,cart-icon-bubble` foi substituído
       pelo caminho nativo do tema: pega a lista de seções do próprio
       <cart-drawer> e chama renderContents(). A seção `cart-icon-bubble`
       nunca existiu neste tema — a API devolvia null e aquele ramo do código
       jamais executava.
     · Os handlers `onclick=` / `onsubmit=` no HTML deram lugar a data
       attributes com listeners delegados. É o que destrava adotar uma
       Content-Security-Policy sem `unsafe-inline`.
     ========================================================================== */

  var TEXT = {
    added: 'ADICIONADO!',
    unavailable: 'Indisponível',
    error: 'Erro',
    sizeRequired: 'Escolha um tamanho'
  };

  function sizesContainerOf(el) {
    var wrapper = el.closest('.product-card-interactive-wrapper');
    return wrapper ? $('.product-card__custom-sizes', wrapper) : null;
  }

  /** Marca o tamanho clicado e libera o botão de compra do card. */
  function selectCardSize(element, variantId, productId) {
    var container = element.parentElement;
    if (container) {
      container.querySelectorAll('.size-square-selector').forEach(function (el) {
        el.style.backgroundColor = 'transparent';
        el.style.borderColor = '';
        el.style.color = '#000';
        el.setAttribute('aria-pressed', 'false');
      });
    }

    element.style.backgroundColor = BRAND;
    element.style.borderColor = BRAND;
    element.style.color = '#fff';
    element.setAttribute('aria-pressed', 'true');

    /* TYNA 2026-07-28 — os lookups eram por getElementById('variant-input-' +
       productId): quando o MESMO produto aparecia duas vezes na página (grid +
       "vistos recentemente"), o clique no segundo card preenchia o input do
       PRIMEIRO, e o submit do segundo acusava "Escolha um tamanho" mesmo com
       tamanho escolhido. Agora tudo é resolvido dentro do próprio card. */
    var wrapper = element.closest('.product-card-interactive-wrapper');
    var input = wrapper ? wrapper.querySelector('input[name="id"]') : null;
    if (input) input.value = variantId;

    var btn = wrapper ? wrapper.querySelector('[data-tyna-add-form] button[type="submit"]') : null;
    if (btn) {
      btn.disabled = false;
      btn.style.cursor = 'pointer';
    }

    clearSizeHint(sizesContainerOf(element));
  }

  /** Adiciona ao carrinho por AJAX e abre o drawer. */
  function handleCardAdd(form, productId) {
    /* TYNA 2026-07-28 — botão resolvido dentro do form recebido, não por id
       global (ids duplicavam quando o produto aparecia 2x na página). */
    var btn = form.querySelector('button[type="submit"]');
    var originalText = btn ? btn.textContent : '';

    function restore(text) {
      if (!btn) return;
      btn.textContent = text;
      setTimeout(function () {
        btn.textContent = originalText;
      }, 2000);
    }

    var drawer = $('cart-drawer');

    // TYNA 2026-07-28 — pede as seções JUNTO no POST /cart/add, numa requisição só.
    // Antes fazíamos um segundo fetch para `?sections=cart-drawer` que, no contexto
    // de preview e em algumas rotas, devolvia a PÁGINA HTML inteira em vez do JSON —
    // o `r.json()` estourava, caía no catch e o cliente via "Erro" no botão, mesmo
    // com o item já no carrinho. Este é o mesmo padrão do product-variants.js do tema.
    var formData = new FormData(form);
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        drawer.getSectionsToRender().map(function (s) { return s.section; }).join(',')
      );
      formData.append('sections_url', window.location.pathname);
    }

    if (btn) btn.textContent = '...';

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: formData
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        // A Cart AJAX API devolve `status` só quando dá erro (ex.: 422 sem estoque).
        if (data.status) {
          restore(TEXT.unavailable);
          return;
        }

        restore(TEXT.added);

        // `data.sections` já veio na resposta do POST. `true` abre o drawer.
        if (drawer && data.sections && typeof drawer.renderContents === 'function') {
          drawer.renderContents(data, true);
        } else {
          window.location = window.routes.cart_url;
        }
      })
      .catch(function (error) {
        console.error('[TYNA] Falha ao adicionar ao carrinho:', error);
        restore(TEXT.error);
      });
  }

  /* --- listeners delegados (substituem os handlers inline) ---------------- */

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || typeof target.closest !== 'function') return;

    var square = target.closest('[data-tyna-size]');
    if (!square) return;

    selectCardSize(square, square.dataset.variantId, square.dataset.productId);
  });

  /**
   * Teclado no seletor de tamanho.
   * O elemento é um <div role="button" tabindex="0">, então o navegador não
   * dispara click no Enter/Espaço como faria num <button> — é preciso tratar.
   * Espaço tem preventDefault para não rolar a página.
   */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var target = e.target;
    if (!target || typeof target.closest !== 'function') return;

    var square = target.closest('[data-tyna-size]');
    if (!square) return;

    e.preventDefault();
    selectCardSize(square, square.dataset.variantId, square.dataset.productId);
  });

  /**
   * Último handler inline do tema: era onclick="preventDefault(event)" em
   * snippets/card-product-small.liquid. Trocado por data attribute para não
   * sobrar `on*` no HTML que nós controlamos.
   */
  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || typeof target.closest !== 'function') return;
    if (target.closest('[data-tyna-prevent-default]')) e.preventDefault();
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || typeof form.matches !== 'function') return;
    if (!form.matches('[data-tyna-add-form]')) return;

    e.preventDefault();

    var productId = form.dataset.productId;
    var input = form.querySelector('input[name="id"]');

    if (!input || !input.value) {
      showSizeHint(form);
      return;
    }

    handleCardAdd(form, productId);
  });

  /* ==========================================================================
     2b. PDP — abrir a gaveta do carrinho depois de adicionar
     ==========================================================================
     assets/product-variants.js (formulário da PDP) publica o evento cartUpdate
     com source "product-form" e depois chama cart.renderContents(response).
     Como o renderContents NÃO abre a gaveta por padrão — e isso é proposital,
     para o quick add não abrir — a abertura da PDP é feita aqui.

     Por que aqui e não mudando o default do renderContents: o default é
     compartilhado por três chamadores com intenções diferentes.
       · PDP       -> deve abrir
       · quick add -> NÃO deve abrir (global.js:2383, sem publish)
       · sincronia -> não deve abrir
     Assinar o evento atinge só a PDP, sem tocar em arquivo do fornecedor.

     `subscribe` é declaração de função no assets/pubsub.js (vira window.*), e
     PUB_SUB_EVENTS é const de nível superior no assets/global.js (fica no escopo
     léxico global, acessível pelo identificador nu). Daí os dois typeof.
     ========================================================================== */

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (data) {
      if (!data || data.source !== 'product-form') return;
      var drawer = $('cart-drawer');
      if (drawer && typeof drawer.open === 'function') drawer.open();
    });
  }

  /* ==========================================================================
     3. CARD DE PRODUTO — aviso "escolha um tamanho"
     ==========================================================================
     O botão nasce ativo. Antes ele nascia `disabled` com `opacity: 0.5`
     inline, mas a regra `body button:disabled { opacity: 1 !important }` do
     layout vencia o estilo inline: o botão aparecia ativo, o cliente clicava
     e nada acontecia, sem nenhuma explicação.
     ========================================================================== */

  // TYNA 2026-07-28 — o aviso é pendurado no wrapper (irmão da grade de
  // tamanhos), não dentro dela. A grade agora é uma única linha sem wrap
  // (flex-wrap:nowrap no mobile) para não quebrar como na home; se o aviso
  // ficasse dentro, não teria como cair para a própria linha.
  function hintHostOf(sizes) {
    return (sizes && sizes.closest('.product-card-interactive-wrapper')) || sizes;
  }

  function clearSizeHint(sizes) {
    if (!sizes) return;
    if (sizes.tynaHintTimer) {
      clearTimeout(sizes.tynaHintTimer);
      sizes.tynaHintTimer = null;
    }
    sizes.classList.remove(SIZE_ATTENTION_CLASS);
    var hint = $('.' + SIZE_HINT_CLASS, hintHostOf(sizes));
    if (hint && hint.parentNode) hint.parentNode.removeChild(hint);
  }

  function showSizeHint(form) {
    var sizes = sizesContainerOf(form);
    if (!sizes) return;

    var host = hintHostOf(sizes);
    var text = form.getAttribute('data-size-required-text') || TEXT.sizeRequired;
    var hint = $('.' + SIZE_HINT_CLASS, host);

    if (!hint) {
      hint = document.createElement('span');
      hint.className = SIZE_HINT_CLASS;
      hint.setAttribute('role', 'alert');
      hint.textContent = text;
      host.appendChild(hint);
    }

    sizes.classList.add(SIZE_ATTENTION_CLASS);

    if (sizes.tynaHintTimer) clearTimeout(sizes.tynaHintTimer);
    sizes.tynaHintTimer = setTimeout(function () {
      clearSizeHint(sizes);
    }, SIZE_HINT_TIMEOUT_MS);
  }

  /* ==========================================================================
     4. CART DRAWER — armadilha de foco
     ==========================================================================
     snippets/cart-drawer.liquid declara role="dialog" e aria-modal="true", mas
     o open() em assets/cart.js nunca chamava trapFocus — embora o tema tenha a
     função pronta e a use em ModalDialog e DropdownInput.

     Consequência: ao abrir o carrinho o foco ficava no fundo, o Tab percorria a
     página por trás do overlay (o aria-modal mentindo), e o handler de Escape
     registrado no próprio <cart-drawer> nunca disparava, porque o foco nunca
     entrava nele.

     Resolvido daqui, observando a classe do elemento, em vez de editar o
     assets/cart.js — que é arquivo do fornecedor.
     ========================================================================== */

  function watchCartDrawerFocus() {
    var drawer = $('cart-drawer');
    if (!drawer) return;

    // trapFocus e removeTrapFocus são declarados com `const` no topo do
    // assets/global.js. `const` de nível superior NÃO vira propriedade de
    // window — mas fica no escopo léxico global, acessível pelo identificador
    // nu a partir de outro script clássico carregado depois. Por isso o guard
    // usa `typeof trapFocus` e não `typeof window.trapFocus`.
    if (typeof trapFocus !== 'function') return;

    var estavaVisivel = drawer.classList.contains('is-visible');

    new MutationObserver(function () {
      var visivel = drawer.classList.contains('is-visible');
      if (visivel === estavaVisivel) return;
      estavaVisivel = visivel;

      if (visivel) {
        trapFocus(drawer);
      } else if (typeof removeTrapFocus === 'function') {
        removeTrapFocus(drawer.activeElement);
      }
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchCartDrawerFocus);
  } else {
    watchCartDrawerFocus();
  }

  /* ==========================================================================
     5. BANNERS — rede de segurança do autoplay de vídeo
     ==========================================================================
     A marcação já sai com autoplay + muted + loop + playsinline (ver
     snippets/tyna-video.liquid). Ainda assim celulares recusam a primeira
     tentativa em algumas situações — Modo de Baixo Consumo no iOS, economia
     de dados no Android, ou o vídeo entrar no DOM depois que o Swiper
     inicializa. Nesses casos o navegador mostra o poster com botão de play.
     ========================================================================== */

  function ensureBannerVideosPlay() {
    /* TYNA 2026-07-28 — WCAG 2.3.3: quem pediu menos movimento no sistema não
       recebe vídeo em loop forçado; o poster com botão de play fica no lugar. */
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var videos = document.querySelectorAll(
      '.hero__media video[autoplay], .section-full-width-banner__media video[autoplay]'
    );

    Array.prototype.forEach.call(videos, function (video) {
      // O tema renderiza o vídeo de desktop E o de mobile, escondendo um por CSS.
      // Medido no navegador: dar play no escondido fazia o navegador baixar os
      // DOIS por inteiro — 16,8 MB na home. Só toca o que está visível.
      if (!video.offsetParent) return;
      // Pausado pelo botão do hero (hero-slider.js): respeita o usuário.
      if (video.dataset.tynaUserPaused === 'true') return;
      // Alguns navegadores só respeitam a propriedade, não o atributo.
      video.muted = true;
      video.playsInline = true;

      var attempt = video.play();
      if (!attempt || typeof attempt.catch !== 'function') return;

      attempt.catch(function () {
        var events = ['touchstart', 'pointerdown', 'scroll'];

        function retry() {
          video.play().catch(function () {
            /* desistimos em silêncio: o poster continua visível */
          });
          events.forEach(function (name) {
            document.removeEventListener(name, retry);
          });
        }

        events.forEach(function (name) {
          document.addEventListener(name, retry, { once: true, passive: true });
        });
      });
    });
  }

  /**
   * O vídeo para quando o slider troca de slide — e nada o retomava.
   * Verificado no navegador: o vídeo do hero tocava até ~3,8s dos 9,8s, o slide
   * virava e ele ficava pausado para sempre, inclusive ao voltar para o slide 1.
   * Era exatamente o "quero o vídeo em loop" que não acontecia.
   *
   * Aqui: a cada troca de slide, toca o vídeo do slide ativo e pausa os demais
   * (parar os invisíveis também economiza banda e CPU).
   */
  function syncHeroSlideVideos() {
    /* TYNA 2026-07-28 — mesmos dois respeitos do ensureBannerVideosPlay:
       reduced-motion do sistema e pausa manual pelo botão do hero. */
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    document.querySelectorAll('.hero__media video').forEach(function (video) {
      var slide = video.closest('.swiper-slide');
      if (!slide) return;
      if (video.dataset.tynaUserPaused === 'true') return;
      if (slide.classList.contains('swiper-slide-active') && video.offsetParent) {
        video.muted = true;
        video.play().catch(function () {});
      } else if (!video.paused) {
        video.pause();
      }
    });
  }

  function hookHeroSlider(tentativa) {
    var hero = document.querySelector('hero-slider');
    if (hero && hero.swiper) {
      hero.swiper.on('slideChange', syncHeroSlideVideos);
      syncHeroSlideVideos();
      return;
    }
    // O Swiper do hero só inicializa no evento `load` ou quando a seção entra na
    // viewport (IntersectionObserver). Tentativas limitadas — não é polling aberto.
    if (!hero || (tentativa || 0) >= 10) return;
    setTimeout(function () { hookHeroSlider((tentativa || 0) + 1); }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureBannerVideosPlay);
  } else {
    ensureBannerVideosPlay();
  }
  // Segunda passada depois do load: o Swiper do hero só inicializa nesse ponto.
  window.addEventListener('load', function () {
    ensureBannerVideosPlay();
    hookHeroSlider(0);
  });
  /* ==========================================================================
     6. QUICK ADD — feedback visual (toast)
     ==========================================================================
     Medido no navegador: adicionar pelo quick cart da home não dava nenhum
     retorno visível — o drawer fechava e só o número do carrinho mudava.
     Muito cliente clica de novo achando que falhou.

     Regra: mostra um toast "Adicionado à sacola" quando a contagem do carrinho
     AUMENTA, exceto se a gaveta do carrinho já estiver aberta (aí a própria
     gaveta é o feedback — caso da PDP e do card, que já a abrem). Assim o toast
     aparece só onde faltava: no quick cart.
     ========================================================================== */

  function badgeCount() {
    var b = $('.cart-count-badge');
    if (!b) return 0;
    var n = parseInt((b.textContent || '').replace(/\D/g, ''), 10);
    return isNaN(n) ? 0 : n;
  }

  function showAddedToast() {
    // Se a gaveta do carrinho está visível, ela já é o feedback.
    var drawer = $('cart-drawer');
    if (drawer && drawer.classList.contains('is-visible')) return;

    var toast = $('#tyna-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'tyna-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.textContent = 'Adicionado à sacola ✓';
    // reinicia a animação
    toast.classList.remove('tyna-toast--show');
    void toast.offsetWidth;
    toast.classList.add('tyna-toast--show');

    if (toast.tynaTimer) clearTimeout(toast.tynaTimer);
    toast.tynaTimer = setTimeout(function () {
      toast.classList.remove('tyna-toast--show');
    }, 2600);
  }

  function watchCartCount() {
    var badge = $('.cart-count-badge');
    if (!badge) return;
    var atual = badgeCount();
    new MutationObserver(function () {
      var novo = badgeCount();
      if (novo > atual) {
        // pequeno atraso: deixa a gaveta (se for abrir) assumir o estado visível
        setTimeout(showAddedToast, 350);
      }
      atual = novo;
    }).observe(badge, { childList: true, characterData: true, subtree: true });
  }

  /* ==========================================================================
     7. MENU MOBILE — aria-expanded nos botões de submenu
     ==========================================================================
     Os botões que abrem submenu (button.menu-link[data-ref]) não expunham
     estado ao leitor de tela. Como 90% do tráfego é mobile, é o menu que a
     maioria usa. Sincronizado aqui, a partir da classe .is-active que o JS do
     tema aplica ao painel-alvo — sem tocar no arquivo do fornecedor.
     ========================================================================== */

  function menuExpanders() {
    return document.querySelectorAll('button.menu-link[data-ref]:not(.menu-header)');
  }

  function syncMenuAria() {
    menuExpanders().forEach(function (btn) {
      var ref = btn.dataset.ref;
      var panel = document.querySelector('.menu-panel[data-menu="' + ref + '"]');
      var aberto = !!(panel && panel.classList.contains('is-active'));
      btn.setAttribute('aria-expanded', aberto ? 'true' : 'false');
      if (panel && !panel.id) panel.id = 'tyna-menu-panel-' + ref;
      if (panel) btn.setAttribute('aria-controls', panel.id);
    });
  }

  function initMenuAria() {
    if (!menuExpanders().length) return;
    syncMenuAria();
    // O JS do tema troca a classe .is-active no clique; sincronizamos depois dele.
    document.addEventListener('click', function (e) {
      if (e.target && typeof e.target.closest === 'function' && e.target.closest('button.menu-link')) {
        setTimeout(syncMenuAria, 550);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      watchCartCount();
      initMenuAria();
    });
  } else {
    watchCartCount();
    initMenuAria();
  }
})();

/* ==========================================================================
   TYNA 2026-07-28 — Frete no QUICK CART (drawer do "+")
   ==========================================================================
   O drawer do "+" (quick-cart-drawer) injeta snippets/quick-cart-product.liquid,
   onde foi adicionada a marcação .tyna-frete com hooks -quick.

   Diferença para o frete da Sacola: aqui o produto AINDA NÃO está no carrinho,
   e /cart/shipping_rates.json calcula sobre o carrinho (carrinho vazio → sem
   taxas). Solução: ao Consultar, adiciona 1 unidade do variant selecionado,
   pega as taxas e RESTAURA a quantidade original (efeito líquido ZERO). Usa
   fetch cru, que não dispara a UI do tema — sem flicker e sem item indesejado.

   Os handlers são delegados no document (o conteúdo do drawer entra via
   innerHTML, então scripts inline não rodariam — por isso o handler é global).
   Reutiliza as classes .tyna-frete (estilo global de cart-drawer.liquid).
   ========================================================================== */
(function () {
  if (window.__tynaFreteQuickInit) return;
  window.__tynaFreteQuickInit = true;

  function digits(s) { return (s || '').replace(/\D/g, ''); }
  function maskCep(v) { v = digits(v).slice(0, 8); return v.length > 5 ? v.slice(0, 5) + '-' + v.slice(5) : v; }
  function brl(n) { n = Number(n) || 0; return n === 0 ? 'Grátis' : 'R$ ' + n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function diasTxt(dd) {
    if (!Array.isArray(dd) || !dd.length) return '';
    var mn = dd[0], mx = dd[dd.length - 1];
    if (mn === mx) return ' · ' + mn + (mn > 1 ? ' dias úteis' : ' dia útil');
    return ' · ' + mn + '-' + mx + ' dias úteis';
  }
  // Mesma tabela do frete da Sacola (Correios, validada 27/27 UFs).
  function ufFromCep(cep) {
    var n = parseInt(String(cep).replace(/\D/g, '').padEnd(8, '0').slice(0, 8), 10);
    if (isNaN(n)) return null;
    var R = [[1000000,19999999,'SP'],[20000000,28999999,'RJ'],[29000000,29999999,'ES'],[30000000,39999999,'MG'],[40000000,48999999,'BA'],[49000000,49999999,'SE'],[50000000,56999999,'PE'],[57000000,57999999,'AL'],[58000000,58999999,'PB'],[59000000,59999999,'RN'],[60000000,63999999,'CE'],[64000000,64999999,'PI'],[65000000,65999999,'MA'],[66000000,68899999,'PA'],[68900000,68999999,'AP'],[69000000,69299999,'AM'],[69300000,69399999,'RR'],[69400000,69899999,'AM'],[69900000,69999999,'AC'],[70000000,72799999,'DF'],[72800000,72999999,'GO'],[73000000,73699999,'DF'],[73700000,76799999,'GO'],[76800000,76999999,'RO'],[77000000,77999999,'TO'],[78000000,78899999,'MT'],[78900000,78999999,'RO'],[79000000,79999999,'MS'],[80000000,87999999,'PR'],[88000000,89999999,'SC'],[90000000,99999999,'RS']];
    for (var i = 0; i < R.length; i++) { if (n >= R[i][0] && n <= R[i][1]) return R[i][2]; }
    return null;
  }
  function msg(out, t) { out.hidden = false; out.innerHTML = '<p class="tyna-frete__msg">' + t + '</p>'; }

  document.addEventListener('input', function (e) {
    var inp = e.target.closest && e.target.closest('[data-tyna-cep-quick]');
    if (!inp) return; inp.value = maskCep(inp.value);
  });
  document.addEventListener('keydown', function (e) {
    var inp = e.target.closest && e.target.closest('[data-tyna-cep-quick]');
    if (inp && e.key === 'Enter') {
      e.preventDefault();
      var box = inp.closest('[data-tyna-frete-quick]');
      var b = box && box.querySelector('[data-tyna-calc-quick]');
      if (b) b.click();
    }
  });

  function selectedVariantId(box) {
    var root = box.closest('quick-cart-drawer') || box.closest('.quick-cart-product') || document;
    var idInput = root.querySelector('.quick-cart-product input[name="id"]') || root.querySelector('input[name="id"]');
    return idInput && idInput.value;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-tyna-calc-quick]');
    if (!btn) return;
    var box = btn.closest('[data-tyna-frete-quick]'); if (!box) return;
    var inp = box.querySelector('[data-tyna-cep-quick]');
    var out = box.querySelector('[data-tyna-result-quick]');
    var cep = digits(inp && inp.value);
    if (cep.length !== 8) { msg(out, 'Digite um CEP válido (8 dígitos).'); return; }
    var uf = ufFromCep(cep);
    if (!uf) { msg(out, 'CEP fora da faixa de entrega. Confira o número.'); return; }
    var vid = selectedVariantId(box);
    if (!vid) { msg(out, 'Selecione um tamanho para calcular o frete.'); return; }

    btn.disabled = true; var oldL = btn.textContent; btn.textContent = '...';
    msg(out, 'Calculando frete…');

    var origQty = 0;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var ex = (cart.items || []).filter(function (it) { return String(it.id) === String(vid); })[0];
        origQty = ex ? ex.quantity : 0;
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: vid, quantity: 1 }) });
      })
      .then(function () {
        return fetch('/cart/shipping_rates.json?shipping_address%5Bzip%5D=' + cep + '&shipping_address%5Bcountry%5D=Brazil&shipping_address%5Bprovince%5D=' + encodeURIComponent(uf), { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); });
      })
      .then(function (res) {
        var rates = res.d && res.d.shipping_rates;
        if (!res.ok || !rates || !rates.length) { out.innerHTML = '<p class="tyna-frete__msg">Não encontramos frete para este CEP. Confira o número.</p>'; return; }
        var html = '<ul class="tyna-frete__list">';
        rates.forEach(function (rt) {
          var nm = (rt.name || 'Frete').replace(/[<>]/g, ''); if (/local delivery/i.test(nm)) nm = 'Entrega Local - Motoboy';
          html += '<li class="tyna-frete__item"><span class="tyna-frete__name">' + nm + diasTxt(rt.delivery_days) + '</span><span class="tyna-frete__price">' + brl(rt.price) + '</span></li>';
        });
        html += '</ul>'; out.innerHTML = html;
      })
      .catch(function () { out.innerHTML = '<p class="tyna-frete__msg">Erro ao calcular. Tente novamente.</p>'; })
      .then(function () {
        // RESTAURA o carrinho ao estado original (efeito líquido zero).
        return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: vid, quantity: origQty }) }).catch(function () {});
      })
      .then(function () { btn.disabled = false; btn.textContent = oldL; })
      .catch(function () { btn.disabled = false; btn.textContent = oldL; });
  });
})();

/* ==========================================================================
   TYNA 2026-07-28 — CEP MEMORIZADO v2: simulação -> checkout com ENDEREÇO
   ==========================================================================
   Pedido do Rodrigo: além do CEP, aplicar o endereço automaticamente.
   Como funciona: quando a cliente completa o CEP na simulação de frete,
   buscamos o endereço no ViaCEP (serviço público padrão do e-commerce BR)
   e, ao clicar em Finalizar, entregamos TUDO ao checkout via parâmetros
   oficiais de pré-preenchimento: rua, cidade, estado e CEP — a cliente
   só digita o número (e bairro, quando o CEP é genérico da cidade).
   O checkout da Shopify não faz busca CEP->rua internamente; por isso a
   resolução acontece aqui, do nosso lado.
   Listener de clique em fase de CAPTURA: roda antes de qualquer outro
   handler do tema (robusto contra stopPropagation).
   Armazenamento: sessionStorage (aba atual; expira ao fechar — LGPD).
   ========================================================================== */
(function () {
  'use strict';

  var CEP_KEY = 'tyna-cep-simulado';
  var ADDR_KEY = 'tyna-endereco-simulado';

  function cepDigits(value) {
    return (value || '').replace(/\D/g, '');
  }
  function cepFormatted(digits) {
    return digits.slice(0, 5) + '-' + digits.slice(5);
  }

  function lookupAddress(digits) {
    fetch('https://viacep.com.br/ws/' + digits + '/json/')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data || data.erro) return;
        try {
          sessionStorage.setItem(ADDR_KEY, JSON.stringify({
            zip: digits,
            address1: data.logradouro || '',
            district: data.bairro || '',
            city: data.localidade || '',
            province: data.uf || ''
          }));
        } catch (err) { /* storage indisponível */ }
      })
      .catch(function () { /* offline/bloqueado: segue só com o CEP */ });
  }

  /* memoriza e resolve o endereço enquanto digita (drawer e quick cart) */
  document.addEventListener('input', function (e) {
    var input = e.target.closest && e.target.closest('[data-tyna-cep], [data-tyna-cep-quick]');
    if (!input) return;
    var digits = cepDigits(input.value);
    if (digits.length === 8) {
      try { sessionStorage.setItem(CEP_KEY, digits); } catch (err) {}
      lookupAddress(digits);
    }
  });

  /* repovoa a calculadora ao focar, se o campo estiver vazio */
  document.addEventListener('focusin', function (e) {
    var input = e.target.closest && e.target.closest('[data-tyna-cep], [data-tyna-cep-quick]');
    if (!input || input.value) return;
    var stored;
    try { stored = sessionStorage.getItem(CEP_KEY); } catch (err) { return; }
    if (stored && stored.length === 8) input.value = cepFormatted(stored);
  });

  /* ao finalizar, leva CEP + endereço resolvido para o checkout (captura) */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('button[name="checkout"], input[name="checkout"], a[href="/checkout"], a[href^="/checkout?"]');
    if (!trigger) return;

    var cep;
    try { cep = sessionStorage.getItem(CEP_KEY); } catch (err) { return; }
    if (!cep || cep.length !== 8) return;

    var params = ['checkout[shipping_address][zip]=' + encodeURIComponent(cepFormatted(cep))];
    try {
      var addr = JSON.parse(sessionStorage.getItem(ADDR_KEY) || 'null');
      if (addr && addr.zip === cep) {
        if (addr.address1) params.push('checkout[shipping_address][address1]=' + encodeURIComponent(addr.address1));
        if (addr.city) params.push('checkout[shipping_address][city]=' + encodeURIComponent(addr.city));
        if (addr.province) params.push('checkout[shipping_address][province]=' + encodeURIComponent(addr.province));
      }
    } catch (err) { /* segue só com o CEP */ }

    e.preventDefault();
    e.stopPropagation();
    window.location.href = '/checkout?' + params.join('&');
  }, true);
})();

/* ==========================================================================
   TYNA 2026-07-29 — Rótulo de tamanho na LEGENDA do variant picker
   ==========================================================================
   O snippet tyna-size-label mapeia U->ÚNICO, 1->PP-P, 2->M-G no HTML
   inicial, mas o JS do tema reescreve <span data-selected-value> com o
   valor CRU a cada troca de variante. Este observador re-aplica o
   mapeamento. Idempotente: os valores mapeados não estão no dicionário,
   então não há loop de mutação.
   ========================================================================== */
(function () {
  'use strict';

  var MAP = { 'u': 'ÚNICO', 'tu': 'ÚNICO', 'único': 'ÚNICO', 'unico': 'ÚNICO', 'one size': 'ÚNICO', '1': 'PP-P', '2': 'M-G' };

  function isSizeFieldset(span) {
    var legend = span.closest('legend');
    if (!legend) return false;
    var t = (legend.textContent || '').toLowerCase();
    return t.indexOf('tamanho') > -1 || t.indexOf('size') > -1;
  }

  function remap(span) {
    var raw = (span.textContent || '').trim().toLowerCase();
    if (MAP[raw] && isSizeFieldset(span)) {
      span.textContent = MAP[raw];
    }
  }

  function watchAll() {
    document.querySelectorAll('[data-selected-value]').forEach(function (span) {
      if (span.dataset.tynaSizeWatched === 'true') return;
      span.dataset.tynaSizeWatched = 'true';
      remap(span);
      new MutationObserver(function () { remap(span); })
        .observe(span, { childList: true, characterData: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchAll);
  } else {
    watchAll();
  }
  /* seções recarregadas (editor de temas / render dinâmico) */
  window.addEventListener('shopify:section:load', watchAll);
})();
